import { EMPTY, Observable } from "rxjs";
import { Reference } from "../inventory/reference/reference";

export function createImageFromBlob(image: Blob, reference: Reference): Observable<string | ArrayBuffer | null> {
  if (image.size == 0) {
    return EMPTY;
  }

  let reader = new FileReader();
  return new Observable<string | ArrayBuffer | null>(observer => {
    reader.addEventListener("load", () => {
      observer.next(reader.result);
      observer.complete();
    }, false);

    reader.readAsDataURL(image);
  });
}